// src/guide/compte/guide_changement_machine.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_click_button,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_changement_machine(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.compte.contrats.changement_machine.page.titre,
    translations.compte.contrats.changement_machine.page.texte,
    "#page_avenant",
    ""
  );

  guide_tour_step_click_button(
    tour,
    translations,
    translations.compte.contrats.changement_machine.versions.titre,
    translations.compte.contrats.changement_machine.versions.texte,
    "#radio",
    "bottom",
    "version_inf_6_4"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.contrats.changement_machine.num_serie_machine_principale
      .titre,
    translations.compte.contrats.changement_machine.num_serie_machine_principale
      .texte,
    "#num_serie_machine_principale",
    "bottom"
  );

  guide_tour_step_click_button(
    tour,
    translations,
    translations.compte.contrats.changement_machine.num_serie_machine_backup
      .titre,
    translations.compte.contrats.changement_machine.num_serie_machine_backup
      .texte,
    "#num_serie_machine_backup",
    "bottom",
    "version_sup_6_4"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.contrats.changement_machine.machine_dev.titre,
    translations.compte.contrats.changement_machine.machine_dev.texte,
    "#machine_dev",
    "bottom",
    "version_inf_6_4"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.contrats.changement_machine.machine_prod.titre,
    translations.compte.contrats.changement_machine.machine_prod.texte,
    "#machine_prod",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.contrats.changement_machine.machine_backup.titre,
    translations.compte.contrats.changement_machine.machine_backup.texte,
    "#machine_backup",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.contrats.changement_machine.ajouter_machine.titre,
    translations.compte.contrats.changement_machine.ajouter_machine.texte,
    "#ajouter_machine",
    "bottom"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.compte.contrats.changement_machine.valider_changement_machine
      .titre,
    translations.compte.contrats.changement_machine.valider_changement_machine
      .texte,
    "#click",
    "top"
  );

  tour.start();
}
